import { getWindowOptions } from './window-options'

function validate (portManager, currentPort, name) {
  switch (name) {
    case 'model':
      return isString(portManager.getValue('model'))
    case 'size':
      if (!isIntString(portManager.getValue('width')) || !isIntString(portManager.getValue('height'))) return false
      let widthIsValid = portManager.getValue('width') >= 200 && portManager.getValue('width') <= 600
      let heightIsValid = false
      // noinspection EqualityComparisonWithCoercionJS
      if (portManager.getValue('model') == '8000') {
        heightIsValid = portManager.getValue('height') >= 295 && portManager.getValue('height') <= 500
      } else {
        heightIsValid = portManager.getValue('height') >= 200 && portManager.getValue('height') <= 500
      }
      return widthIsValid && heightIsValid
    case 'color':
      return isRal(portManager.getValue('color')) && portManager.getValidModelColors(portManager.getValue('model')).indexOf(parseInt(portManager.getValue('color'))) >= 0
    case 'windows':
      return isStringAndNotEmpty(portManager.getValue('windows')) && getWindowOptions(portManager.getValue('model'), portManager.getValue('width'), portManager.getValue('height')).indexOf(portManager.getValue('windows')) >= 0
    case 'door':
      if (portManager.getValue('door') === 'left' || portManager.getValue('door') === 'right') {
        return portManager.when('doorAllowedSide')
      }
      if (portManager.getValue('door') === 'center') {
        return portManager.when('doorAllowedCenter')
      }
      return isStringAndNotEmpty(portManager.getValue('door'))
    case 'door_direction':
      if (portManager.getValue('door') === 'none') return true // If no door then this doesn't matter
      return isStringAndNotEmpty(portManager.getValue('door_direction'))
    case 'steps':
      if (portManager.getValue('door') === 'none') return true // If no door then this doesn't matter
      return isStringAndNotEmpty(portManager.getValue('steps'))
    case 'motor':
      return isStringAndNotEmpty(portManager.getValue('motor'))
    case 'upper_height':
      return isIntString(portManager.getValue('upper_height')) && portManager.getValue('upper_height') <= 300 && portManager.getValue('upper_height') >= (portManager.getValue('model') === '9000' ? 20 : 50)

    case 'rent_lift':
      const _settings = portManager.settings.getInputSettings('rent_lift')
      const liftRequiredHeight = _settings?.max_height ?? 500
      if (Number(portManager.getValue('upper_height')) + Number(portManager.getValue('height')) <= liftRequiredHeight) {
        return true
      }
      return isStringAndNotEmpty(portManager.getValue('rent_lift'))
    case 'rails_type':
      if (!isStringAndNotEmpty(portManager.getValue('rails_type'))) return false
      if (portManager.getValue('rails_type') === 'low' && portManager.getValue('model') !== '9000') return false // "low" is only for model 9000
      if (portManager.getValue('rails_type') === 'low' && (portManager.getValue('upper_height') < 20 || portManager.getValue('upper_height') > 50)) return false // "low" is between 20cm and 50cm
      if (portManager.getValue('rails_type') === 'high' && (portManager.getValue('upper_height') < 70 || portManager.getValue('upper_height') > 300)) return false // "high" is between 70cm and 300cm
      return true
    case 'roof_has_angle':
      return isStringAndNotEmpty(portManager.getValue('roof_has_angle'))
    case 'roof_angle':
      if (portManager.getValue('roof_has_angle') !== 'yes') return true // If no angle then this doesn't matter
      return isIntString(portManager.getValue('roof_angle')) && parseInt(portManager.getValue('roof_angle')) >= 0 && parseInt(portManager.getValue('roof_angle')) <= 20
    case 'delivery':
      return isStringAndNotEmpty(portManager.getValue('delivery'))
    case 'installation':
      return isStringAndNotEmpty(portManager.getValue('installation'))
    case 'date':
      if (portManager.getValue('installation') !== 'yes') return true // If no installation then this doesn't matter
      return isIntString(portManager.getValue('date')) || isInt(portManager.getValue('date'))
    case 'uninstallation':
      if (!isStringAndNotEmpty(portManager.getValue('uninstallation'))) return false
      return portManager.getValue('installation') === 'no' ? portManager.getValue('uninstallation') !== 'yes' : true
    default:
      return true
  }
}

function isString (value) {
  return typeof value === 'string'
}

function isStringAndNotEmpty (value) {
  return isString(value) && value.length > 0
}

function isRal (value) {
  if (!isString(value)) return false
  let match = value.match(/\d{4}/)
  return match !== null && match.length === 1
}

function isIntString (value) {
  if (!isStringAndNotEmpty(value)) return false
  let match = value.match(/^\d*$/)
  return match !== null && match.length === 1
}

function isInt (value) {
  return Number.isInteger(value)
}

export default validate